
var FileSaver = require('file-saver');
function b64toFile(b64Data, filename, contentType) {
  let sliceSize = 512;
  let byteCharacters = atob(b64Data);
  let byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);
      let byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
  }

  let file = new File(byteArrays, filename, {type: contentType});
  return file;
}
function download(base64Data, name){
  // base64Data 是服务器获取到的数据
  let file = b64toFile(base64Data, 'test', 'application/vnd.ms-excel;charset=utf-8');
  // 利用FileSaver.js 下载文件为Excel文件
  FileSaver.saveAs(file, name);
}



function imgToFile(dataurl, filename) { //将base64转换为文件
  var arr = dataurl.split(','), 
  mime = arr[0].match(/:(.*?);/)[1],
  bstr = atob(arr[1]), 
  n = bstr.length, 
  u8arr = new Uint8Array(n);
  while(n--){
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, {type:mime});
}
export default {
  download: download,
  imgToFile: imgToFile
}


// WEBPACK FOOTER //
// ./src/util/file.js